import { render } from "./StakeholderForm.vue?vue&type=template&id=5f12347e"
import script from "./StakeholderForm.vue?vue&type=script&lang=js"
export * from "./StakeholderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__